import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import PTTrialFilters from "./PTTrialFilters";
import PTTrackCards from "./PTTrackCards";
import GymWiseStats from "./GymWiseStats";
import PTReports from "./pt-reports/PTReports";
import {
  fetchPTTrialStatsData,
  fetchPtTracksData,
  totalHandoverByMeData,
  totalSubsGymwiseData,
  totalTrialInitiatedByMeData,
} from "../../redux/reducers/apiSlice";
import PTTableFilters from "./common/PTTableFilters";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import PTTrialTable1 from "./PTTrialTable1";
import PTTrialForm from "./PTTrialForm";
import ReceptionistForm from "./open-tracks/ReceptionistForm";
import ModalHeader from "../ModalHeader";
import SelectExportables from "../common-components/SelectExportables";
import { exportableData } from "./common/SharedDatas";
import { fetchExportApiData } from "../../redux/reducers/commonApiSlice";
import { ptTrackDataExport } from "../../data/ApiEndpoints";
import BackAddBtns from "../Open-pages/target-matrics/common/BackAddBtns";
import TableSkeleton from "../common-components/TableSkeleton";
import "../../styles/pt/pt-track-tables.css";
import MemberReport from "./member-report/MemberReport";
import { isManagerRole as checkIsManagerRole } from "../common-data/Conversions";

const PTTrackStructure = ({ decryptedText, isOpenAccessible }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    ptTrialStatsLoading,
    ptTrialStatsData,

    ptTracksData,
    ptTracksDataLoading,
    ptTracksDataError,

    totalSubscriptionGymwise,
    totalSubscriptionGymwiseLoading,
    totalSubscriptionGymwiseError,

    handoverByMe,
    handoverByMeLoading,
    handoverByMeError,

    trialInitiatedByMe,
    trialInitiatedByMeLoading,
    trialInitiatedByMeError,
  } = useSelector((state) => state.api);
  const { exportData, exportLoading } = useSelector((state) => state.common);

  const isAdmin = decryptedText?.account_type === "admin";
  const isTrainer = decryptedText?.account_type === "trainer";
  const isReceptionist = decryptedText?.account_type === "receptionist";
  const isFitnessManager = decryptedText?.account_type === "fitness_manager";
  const isManagerRole = checkIsManagerRole(decryptedText);
  // Multi-gym managers (sales/fitness/club/cluster_manager) — they may have
  // multiple authorized gyms. Excludes "gym" account_type which is single-gym.
  const isMultiGymManager = [
    "sales_manager",
    "fitness_manager",
    "club_manager",
    "cluster_manager",
  ].includes(decryptedText?.account_type);

  const [trainerReceptionistInfo, setTrainerReceptionistInfo] = useState(
    decryptedText || {}
  );

  const extractCheckinTimes = (checkinArray) => {
    let last_checkin_start_end_time = [];

    checkinArray?.length > 0 &&
      checkinArray.forEach((item) => {
        const itemValue = item.value;
        last_checkin_start_end_time.push(itemValue);
      });

    return {
      last_checkin_start_end_time: last_checkin_start_end_time.join(", "),
    };
  };
  const [toggle, setToggle] = useState(false);
  const initialFilters = {
    searchString: "",
    // Auto-lock the gym filter to the user's primary gym for every non-admin
    // role. Multi-gym managers can still change it via the dropdown (when they
    // have access to multiple authorized gyms). Backend now enforces that the
    // selected gym is in the user's authorized list (helpers/gymAccessControl.js)
    // so even if the frontend sends an unauthorized gym_id, backend returns 403.
    selectedGym:
      !isAdmin
        ? { label: decryptedText?.gym_name, value: decryptedText?.gym_id }
        : "",
    selectedTrainer: isTrainer
      ? {
          label: decryptedText?.name,
          value: decryptedText?.uid || decryptedText?.user_id,
        }
      : "",
    selectedSubsAddedBy: "",
    selectedReceptionist: isReceptionist
      ? {
          label: decryptedText?.name,
          value: decryptedText?.uid || decryptedText?.user_id,
        }
      : "",
    selectedPTTrialStatus: "",
    selectedHandoverStatus: isTrainer
      ? { label: "Handover Completed", value: "handover_completed" }
      : "",
    selPTProspect: "",
    selProspectStatus: "",
    selectedCard: "",
    trialCompletedOn: "",
    handoverCompletedOn: "",
    lastCheckedIn: "",
    selLeastCheckinInBetween: [],
    selBiomaxAppRegister: "",
    selTrialAddedFrom: "",
    selectedPTTrial: "",
    selectedPTTrialStartStatus: "",
    selectedConvertedStatus: "",
    selectedPaymentLocation: "",

    selSubscriptionAddDateFrom: "",
    selSubscriptionAddDateTo: "",
    selPtScheduleDateFrom: "",
    selPtScheduleDateTo: "",
    selExpCloserDateFrom: "",
    selExpCloserDateTo: "",
    selPtTrialAssignedDateFrom: "",
    selPtTrialAssignedDateTo: "",
    selPtInitiatedDateFrom: "",
    selPtInitiatedDateTo: "",
    bcaReportStatus: "",
    threeDayDoneCount: "",
    selThreeDayDoneDateFrom: "",
    selThreeDayDoneDateTo: "",

    isFutureSubscription: false,
  };
  const [filters, setFilters] = useState(initialFilters);
  const { last_checkin_start_end_time } = extractCheckinTimes(
    filters.selLeastCheckinInBetween
  );
  const iniSendableFilters = {
    gym_id: filters.selectedGym?.value || "",
    assigned_to:
      isTrainer && trainerReceptionistInfo?.user_id
        ? trainerReceptionistInfo.user_id
        : filters.selectedTrainer?.value
        ? filters.selectedTrainer.value
        : "",
    sub_added_by: filters.selectedSubsAddedBy?.value || "",
    assigned_by: filters.selectedReceptionist?.value || "",
    trial_status: filters.selectedPTTrialStatus?.value || "",
    handover_status: filters.selectedHandoverStatus?.value
      ? filters.selectedHandoverStatus.value
      : isTrainer
      ? "handover_completed"
      : "",
    pt_initiate_date_days_ago: filters.trialCompletedOn?.value || "",
    assigned_date_days_ago: filters.handoverCompletedOn?.value || "",
    last_checkin_days_ago: filters.lastCheckedIn?.value || "",
    trnr_intro_status: filters.selTrainerIntro?.value || "",
    is_pt_prspct: filters.selPTProspect?.value || "",
    prspct_status: filters.selProspectStatus?.value || "",
    last_checkin_time_filter: last_checkin_start_end_time || "",
    biomax_first_step: filters.selBiomaxAppRegister?.value || "",
    added_from: filters.selTrialAddedFrom?.value || "",
    three_day_assigned: filters.selectedPTTrial?.value || "",
    pt_trial_start_status: filters.selectedPTTrialStartStatus?.value || "",
    converted: filters.selectedConvertedStatus?.value || "",

    start_date: filters.selSubscriptionAddDateFrom || "",
    end_date: filters.selSubscriptionAddDateTo || "",
    pt_schedule_start_date: filters.selPtScheduleDateFrom || "",
    pt_schedule_end_date: filters.selPtScheduleDateTo || "",
    expctd_closure_start_date: filters.selExpCloserDateFrom || "",
    expctd_closure_end_date: filters.selExpCloserDateTo || "",
    threeday_assign_from: filters.selPtTrialAssignedDateFrom || "",
    threeday_assign_to: filters.selPtTrialAssignedDateTo || "",
    payment_location: filters.selectedPaymentLocation?.value || "",
    bca_report_status: filters.bcaReportStatus?.value || "",
    three_day_done_count: filters.threeDayDoneCount?.value || "",
    three_day_done_from: filters.selThreeDayDoneDateFrom || "",
    three_day_done_to: filters.selThreeDayDoneDateTo || "",

    is_future_subscription: filters.isFutureSubscription || false,
    future_trial: toggle ? 1 : 0,
  };
  const [sendableFilters, setSendableFilters] = useState(iniSendableFilters);
  const iniSendableStatsFilters = {
    gym_id: filters.selectedGym?.value ? filters.selectedGym.value : "",
    assigned_to:
      isTrainer && trainerReceptionistInfo?.user_id
        ? trainerReceptionistInfo.user_id
        : "",
    handover_status: filters.selectedHandoverStatus?.value
      ? filters.selectedHandoverStatus.value
      : isTrainer
      ? "handover_completed"
      : "",
    start_date: filters.selSubscriptionAddDateFrom || "",
    end_date: filters.selSubscriptionAddDateTo || "",
    payment_location: filters.selectedPaymentLocation?.value || "",
    future_trial: toggle ? 1 : 0,
  };
  const [sendableStatsFilters, setSendableStatsFilters] = useState(
    iniSendableStatsFilters
  );
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const initCardValues = {
    total: "0",
    total_completed: "0",
    total_converted: "0",
    total_pending: "0",
    total_handover: "0",
    total_handover_completed: "0",
    total_handover_converted: "0",
    total_handover_pending: "0",
    total_pt_prspct: "0",
    total_pt_prspct_value: "",
    trial_done_cnvrtd: "",
    trial_notdone_cnvrtd: "",
    bca_doc_completed: "",
    bca_doc_pending: "",
  };
  const iniPTDatas = {
    ptCardData: initCardValues,
    isPage: 0,
    pageLimit: 10,
    pagination: [],
    allPTTracksData: [],
  };
  const [ptDatas, setPTDatas] = useState(iniPTDatas);
  const [showTable, setShowTable] = useState(false);
  const [activeKey, setActiveKey] = useState(null);
  const [isAddedByMe, setIsAddedByMe] = useState("");
  const iniAddedByMe = {
    totalSubs: 0,
    totalSubsData: [],
    subsIsPage: 0,
    subsPagination: [],

    totalHandover: 0,
    totalHandoverData: [],
    handIsPage: 0,
    handPagination: [],

    totalInitiated: 0,
    totalInitiatedData: [],
    trialIsPage: 0,
    trialPagination: [],
  };
  const [addedByMe, setAddedByMe] = useState(iniAddedByMe);
  const [pttModal, setPTTModal] = useState(false);
  const handleToggle = () => {
    setToggle((prev) => !prev);
  };
  const initialClickValues = {
    isModOpen: false,
    name: "",
  };
  const [clickValues, setClickValues] = useState(initialClickValues);
  const [csvData, setCsvData] = useState();
  const ptReportsFilters = {
    selectedGym: filters?.selectedGym || "",
    selectedTrainer: filters?.selectedTrainer || "",
    selectedHandoverStatus: filters?.selectedHandoverStatus || "",
    selSubscriptionAddDateFrom: filters?.selSubscriptionAddDateFrom || "",
    selSubscriptionAddDateTo: filters?.selSubscriptionAddDateTo || "",
  };

  const onClickReset = () => {
    setFilters(initialFilters);
    setPTDatas((prevs) => ({ ...prevs, isPage: 0 }));
    setToggle(false);
  };

  const onClickResetStats = () => {
    setFilters(initialFilters);
    setActiveKey(null);
    setIsAddedByMe(false);
    setToggle(false);
  };

  const onCLoseModal = () => {
    setFilters((prevs) => ({
      ...prevs,
      searchString: "",
      selectedTrainer: isTrainer
        ? {
            label: decryptedText?.name,
            value: decryptedText?.uid || decryptedText?.user_id,
          }
        : "",
      selectedSubsAddedBy: "",
      selectedReceptionist: "",
      selectedPTTrialStatus: "",
      selPTProspect: "",
      selProspectStatus: "",
      selLeastCheckinInBetween: [],
      selectedHandoverStatus: "",
      lastCheckedIn: "",
      trialCompletedOn: "",
      handoverCompletedOn: "",
      selTrainerIntro: "",
      selPtScheduleDateFrom: "",
      selPtScheduleDateTo: "",
      selExpCloserDateFrom: "",
      selExpCloserDateTo: "",
      selPtTrialAssignedDateFrom: "",
      selPtTrialAssignedDateTo: "",
      selectedCard: "",
      selTrialAddedFrom: "",
      selectedPTTrial: "",
      selectedPTTrialStartStatus: "",
      selectedConvertedStatus: "",
      bcaReportStatus: "",
      threeDayDoneCount: "",
      selThreeDayDoneDateFrom: "",
      selThreeDayDoneDateTo: "",
      isFutureSubscription: false,
    }));
    setSendableFilters(iniSendableFilters);
    setSendableStatsFilters(iniSendableStatsFilters);
    setPTDatas((prevs) => ({ ...prevs, isPage: 0 }));
    setActiveKey(null);
    setIsAddedByMe(false);
    setShowTable(false);
  };

  const closeOpenModal = () => {
    setPTTModal(false);
  };

  const onCloseClickValuesModal = () => {
    setClickValues(initialClickValues);
  };

  const handleBack = (e) => {
    e.preventDefault();

    navigate("/open-access/all-pages", {
      state: { userInfo: decryptedText, decryptedText },
    });
  };

  const onClickSearch = () => {
    if (filters.searchString) {
      setSendableFilters((prevs) => ({
        ...prevs,
        search: filters.searchString,
      }));
      setSearchFilterApplied(true);
      setPTDatas((prevs) => ({ ...prevs, isPage: 0 }));
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };

  const onClickExport = (filters) => {
    dispatch(
      fetchExportApiData({
        method: "GET",
        endpoint: ptTrackDataExport,
        payload: {
          filters: filters,
        },
        token: decryptedText?.token,
      })
    );
  };

  function getPTTrialStatsData(sendableStatsFilters) {
    const filteredParams = Object.entries(sendableStatsFilters)
      .filter(([_, value]) => value !== "")
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&");

    const queryParameters = filteredParams;

    dispatch(
      fetchPTTrialStatsData({
        queryParameters: queryParameters,
        token: decryptedText?.token,
      })
    );
  }

  function getPtTracksData(sendableFilters) {
    const { page, limit, ...rest } = sendableFilters;
    const filteredParams = Object.entries(rest)
      .filter(([_, value]) => value !== "")
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&");

    const queryParameters = filteredParams;

    dispatch(
      fetchPtTracksData({
        pageNo: ptDatas.isPage + 1 || 1,
        limit: ptDatas.pageLimit || 10,
        queryParameters: queryParameters,
        token: decryptedText?.token,
      })
    );
  }

  const handleTotalSubsGymwiseData = (userId) => {
    dispatch(
      totalSubsGymwiseData({
        pageNo: addedByMe.subsIsPage + 1,
        limit: 10,
        queryParameters: `${
          isReceptionist || isFitnessManager ? "&sub_added_by=" + userId : ""
        }${
          trainerReceptionistInfo?.gym_id
            ? "&gym_id=" + trainerReceptionistInfo.gym_id
            : ""
        }${toggle ? "&future_trial=1" : ""}`,
        token: decryptedText?.token,
      })
    );
  };

  const handleTotalHandoverByMeData = (userId) => {
    dispatch(
      totalHandoverByMeData({
        pageNo: addedByMe.handIsPage + 1,
        limit: 10,
        queryParameters: `${
          isReceptionist || isFitnessManager ? "&assigned_by=" + userId : ""
        }${
          trainerReceptionistInfo?.gym_id
            ? "&gym_id=" + trainerReceptionistInfo.gym_id
            : ""
        }${toggle ? "&future_trial=1" : ""}`,
        token: decryptedText?.token,
      })
    );
  };

  const handleTotalTrialInitiatedByMeData = (ftMnagerId) => {
    dispatch(
      totalTrialInitiatedByMeData({
        pageNo: addedByMe.trialIsPage + 1,
        limit: 10,
        queryParameters: `${
          isFitnessManager ? "&assigned_to=" + ftMnagerId : ""
        }${
          trainerReceptionistInfo?.gym_id
            ? "&gym_id=" + trainerReceptionistInfo.gym_id
            : ""
        }${toggle ? "&future_trial=1" : ""}`,
        token: decryptedText?.token,
      })
    );
  };

  useEffect(() => {
    if (decryptedText) {
      setTrainerReceptionistInfo(decryptedText);
    } else if (isOpenAccessible) {
      setTrainerReceptionistInfo({});
      navigate("/open-access");
    } else {
      setTrainerReceptionistInfo({});
    }
  }, [decryptedText]);

  //   UPDATE STATE setSendableFilters
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSendableStatsFilters((prevs) => ({
        ...prevs,
        gym_id:
          (isReceptionist || isTrainer) && trainerReceptionistInfo?.gym_id
            ? trainerReceptionistInfo.gym_id
            : filters.selectedGym?.value
            ? filters.selectedGym.value
            : "",
        assigned_to:
          isTrainer && trainerReceptionistInfo?.user_id
            ? trainerReceptionistInfo.user_id
            : filters.selectedTrainer?.value
            ? filters.selectedTrainer.value
            : "",
        handover_status: isTrainer
          ? "handover_completed"
          : filters.selectedHandoverStatus?.value
          ? filters.selectedHandoverStatus.value
          : "",
        start_date: filters.selSubscriptionAddDateFrom || "",
        end_date: filters.selSubscriptionAddDateTo || "",
        payment_location: filters.selectedPaymentLocation?.value || "",
        future_trial: toggle ? 1 : 0,
      }));
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [
    filters.selectedGym?.value,
    filters.selectedTrainer?.value,
    filters.selectedHandoverStatus?.value,
    filters.selSubscriptionAddDateFrom,
    filters.selSubscriptionAddDateTo,
    trainerReceptionistInfo?.gym_id,
    trainerReceptionistInfo?.user_id,
    isTrainer,
    isReceptionist,
    toggle,
  ]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSendableFilters((prevs) => ({
        ...prevs,
        gym_id:
          (isReceptionist || isTrainer) && trainerReceptionistInfo?.gym_id
            ? trainerReceptionistInfo.gym_id
            : filters.selectedGym?.value || "",
        assigned_to:
          isTrainer && trainerReceptionistInfo?.user_id
            ? trainerReceptionistInfo.user_id
            : filters.selectedTrainer?.value || "",
        sub_added_by: filters.selectedSubsAddedBy?.value || "",
        assigned_by: filters.selectedReceptionist?.value || "",
        trial_status: filters.selectedPTTrialStatus?.value || "",
        prspct_status: filters.selProspectStatus?.value || "",
        handover_status: filters.selectedHandoverStatus?.value
          ? filters.selectedHandoverStatus.value
          : isTrainer
          ? "handover_completed"
          : "",
        pt_initiate_date_days_ago: filters.trialCompletedOn?.value || "",
        assigned_date_days_ago: filters.handoverCompletedOn?.value || "",
        last_checkin_days_ago: filters.lastCheckedIn?.value || "",
        trnr_intro_status: filters.selTrainerIntro?.value || "",
        is_pt_prspct: filters.selPTProspect?.value || "",
        last_checkin_time_filter: last_checkin_start_end_time || "",
        biomax_first_step: filters.selBiomaxAppRegister?.value || "",
        added_from: filters.selTrialAddedFrom?.value || "",
        three_day_assigned: filters.selectedPTTrial?.value || "",
        converted: filters.selectedConvertedStatus?.value || "",
        start_date: filters.selSubscriptionAddDateFrom || "",
        end_date: filters.selSubscriptionAddDateTo || "",
        pt_schedule_start_date: filters.selPtScheduleDateFrom || "",
        pt_schedule_end_date: filters.selPtScheduleDateTo || "",
        expctd_closure_start_date: filters.selExpCloserDateFrom || "",
        expctd_closure_end_date: filters.selExpCloserDateTo || "",
        threeday_assign_from: filters.selPtTrialAssignedDateFrom || "",
        threeday_assign_to: filters.selPtTrialAssignedDateTo || "",
        payment_location: filters.selectedPaymentLocation?.value || "",
        bca_report_status: filters.bcaReportStatus?.value || "",
        three_day_done_count: filters.threeDayDoneCount?.value || "",
        three_day_done_from: filters.selThreeDayDoneDateFrom || "",
        three_day_done_to: filters.selThreeDayDoneDateTo || "",
        is_future_subscription: filters.isFutureSubscription || false,
        future_trial: toggle ? 1 : 0,
      }));
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [
    filters.selectedGym?.value,
    filters.selectedTrainer?.value,
    filters.selectedSubsAddedBy?.value,
    filters.selectedReceptionist?.value,
    filters.selectedPTTrialStatus?.value,
    filters.selProspectStatus?.value,
    filters.selectedHandoverStatus?.value,
    filters.trialCompletedOn?.value,
    filters.handoverCompletedOn?.value,
    filters.lastCheckedIn?.value,
    filters.selTrainerIntro?.value,
    filters.selPTProspect?.value,
    filters.selBiomaxAppRegister?.value,
    filters.selTrialAddedFrom?.value,
    filters.selectedPTTrial?.value,
    filters.selectedConvertedStatus?.value,
    filters.selSubscriptionAddDateFrom,
    filters.selSubscriptionAddDateTo,
    filters.selPtScheduleDateFrom,
    filters.selPtScheduleDateTo,
    filters.selExpCloserDateFrom,
    filters.selExpCloserDateTo,
    filters.selPtTrialAssignedDateFrom,
    filters.selPtTrialAssignedDateTo,
    filters.selectedPaymentLocation?.value,
    filters.bcaReportStatus?.value,
    filters.threeDayDoneCount?.value,
    filters.selThreeDayDoneDateFrom,
    filters.selThreeDayDoneDateTo,
    filters.isFutureSubscription,
    toggle,
    last_checkin_start_end_time,
    trainerReceptionistInfo?.gym_id,
    trainerReceptionistInfo?.user_id,
    isTrainer,
    isReceptionist,
  ]);

  useEffect(() => {
    setSendableFilters((prevs) => ({
      ...prevs,
      page: ptDatas.isPage + 1,
    }));
  }, [ptDatas.isPage]);

  useEffect(() => {
    setSendableFilters((prevs) => ({
      ...prevs,
      limit: ptDatas.pageLimit || 10,
    }));
  }, [ptDatas.pageLimit]);

  //   CALL getPTTrialStatsData
  useEffect(() => {
    if (isTrainer) {
      if (sendableStatsFilters.assigned_to) {
        getPTTrialStatsData(sendableStatsFilters);
      }
    } else {
      getPTTrialStatsData(sendableStatsFilters);
    }
  }, [sendableStatsFilters]);

  //   CALL getPtTracksData
  useEffect(() => {
    if (isTrainer) {
      if (sendableFilters.assigned_to) {
        getPtTracksData(sendableFilters);
      }
    } else {
      getPtTracksData(sendableFilters);
    }
  }, [sendableFilters, ptDatas.isPage, ptDatas.pageLimit]);

  //   ptTrialStatsData - UPDATE STATE setPTDatas - ptCardData
  useEffect(() => {
    if (
      !ptTrialStatsLoading &&
      ptTrialStatsData?.status &&
      ptTrialStatsData?.all_data_count
    ) {
      const { all_data_count } = ptTrialStatsData || {};

      setPTDatas((prevs) => ({
        ...prevs,
        ptCardData: all_data_count,
      }));
    } else {
      setPTDatas((prevs) => ({
        ...prevs,
        ptCardData: null,
      }));
    }
  }, [ptTrialStatsData, ptTrialStatsLoading]);

  //   ptTracksData - UPDATE STATE setPTDatas - allPTTracksData | pagination
  useEffect(() => {
    if (
      !ptTracksDataLoading &&
      !ptTracksDataError &&
      ptTracksData?.status &&
      ptTracksData?.data?.length > 0
    ) {
      const { data, pagination } = ptTracksData || {};

      setPTDatas((prevs) => ({
        ...prevs,
        allPTTracksData: data,
        pagination: pagination,
      }));
    } else {
      setPTDatas((prevs) => ({
        ...prevs,
        allPTTracksData: [],
        pagination: [],
      }));
    }
  }, [ptTracksData, ptTracksDataLoading, ptTracksDataError]);

  //   CALL handleTotalSubsGymwiseData | handleTotalHandoverByMeData
  useEffect(() => {
    if (
      !isAdmin &&
      (isReceptionist || isFitnessManager) &&
      trainerReceptionistInfo?.user_id
    ) {
      handleTotalSubsGymwiseData(trainerReceptionistInfo.user_id);
      handleTotalHandoverByMeData(trainerReceptionistInfo.user_id);
    }
  }, [addedByMe.subsIsPage, addedByMe.handIsPage]);

  // CALL handleTotalTrialInitiatedByMeData
  useEffect(() => {
    if (!isAdmin && isFitnessManager && trainerReceptionistInfo?.user_id) {
      handleTotalTrialInitiatedByMeData(trainerReceptionistInfo.user_id);
    }
  }, [addedByMe.trialIsPage]);

  // totalSubscriptionGymwise
  useEffect(() => {
    if (
      !totalSubscriptionGymwiseLoading &&
      !totalSubscriptionGymwiseError &&
      totalSubscriptionGymwise?.status &&
      totalSubscriptionGymwise?.data?.length > 0
    ) {
      const { data, pagination } = totalSubscriptionGymwise;
      const { total } = totalSubscriptionGymwise.all_data_count;
      setAddedByMe((prevs) => ({
        ...prevs,
        totalSubs: total,
        totalSubsData: data,
        subsPagination: pagination,
      }));
    } else {
      setAddedByMe((prevs) => ({
        ...prevs,
        totalSubs: 0,
        totalSubsData: [],
        subsPagination: [],
      }));
    }
  }, [
    totalSubscriptionGymwiseLoading,
    totalSubscriptionGymwiseError,
    totalSubscriptionGymwise,
  ]);

  // handoverByMe
  useEffect(() => {
    if (
      !handoverByMeLoading &&
      !handoverByMeError &&
      handoverByMe?.status &&
      handoverByMe?.data?.length > 0
    ) {
      const { data, pagination } = handoverByMe;
      const { total } = handoverByMe.all_data_count;
      setAddedByMe((prevs) => ({
        ...prevs,
        totalHandover: total,
        totalHandoverData: data,
        handPagination: pagination,
      }));
    } else {
      setAddedByMe((prevs) => ({
        ...prevs,
        totalHandover: 0,
        totalHandoverData: [],
        handPagination: [],
      }));
    }
  }, [handoverByMeLoading, handoverByMeError, handoverByMe]);

  // trialInitiatedByMe
  useEffect(() => {
    if (!isAdmin) {
      if (
        !trialInitiatedByMeLoading &&
        !trialInitiatedByMeError &&
        trialInitiatedByMe?.status &&
        trialInitiatedByMe?.data?.length > 0
      ) {
        const { data, pagination } = trialInitiatedByMe;
        const { total } = trialInitiatedByMe.all_data_count;
        setAddedByMe((prevs) => ({
          ...prevs,
          totalInitiated: total,
          totalInitiatedData: data,
          trialPagination: pagination,
        }));
      } else {
        setAddedByMe((prevs) => ({
          ...prevs,
          totalInitiated: 0,
          totalInitiatedData: [],
          trialPagination: [],
        }));
      }
    }
  }, [trialInitiatedByMeLoading, trialInitiatedByMeError, trialInitiatedByMe]);

  // exportData
  useEffect(() => {
    if (exportData) {
      setCsvData(exportData);
    } else {
      setCsvData();
    }
  }, [exportData]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSendableStatsFilters((prevs) => ({
        ...prevs,
        gym_id:
          (isReceptionist || isTrainer) && trainerReceptionistInfo?.gym_id
            ? trainerReceptionistInfo.gym_id
            : filters.selectedGym?.value || "",
        assigned_to:
          isTrainer && trainerReceptionistInfo?.user_id
            ? trainerReceptionistInfo.user_id
            : filters.selectedTrainer?.value || "",
        handover_status: filters.selectedHandoverStatus?.value
          ? filters.selectedHandoverStatus.value
          : isTrainer
          ? "handover_completed"
          : "",
        start_date: filters.selSubscriptionAddDateFrom || "",
        end_date: filters.selSubscriptionAddDateTo || "",
        payment_location: filters.selectedPaymentLocation?.value || "",
        future_trial: toggle ? 1 : 0,
      }));
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [
    filters.selectedGym?.value,
    filters.selectedTrainer?.value,
    filters.selectedHandoverStatus?.value,
    filters.selSubscriptionAddDateFrom,
    filters.selSubscriptionAddDateTo,
    trainerReceptionistInfo?.gym_id,
    trainerReceptionistInfo?.user_id,
    isTrainer,
    isReceptionist,
    toggle,
  ]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSendableFilters((prevs) => ({
        ...prevs,
        gym_id:
          (isReceptionist || isTrainer) && trainerReceptionistInfo?.gym_id
            ? trainerReceptionistInfo.gym_id
            : filters.selectedGym?.value || "",
        assigned_to:
          isTrainer && trainerReceptionistInfo?.user_id
            ? trainerReceptionistInfo.user_id
            : filters.selectedTrainer?.value || "",
        sub_added_by: filters.selectedSubsAddedBy?.value || "",
        assigned_by: filters.selectedReceptionist?.value || "",
        trial_status: filters.selectedPTTrialStatus?.value || "",
        prspct_status: filters.selProspectStatus?.value || "",
        handover_status: filters.selectedHandoverStatus?.value
          ? filters.selectedHandoverStatus.value
          : isTrainer
          ? "handover_completed"
          : "",
        pt_initiate_date_days_ago: filters.trialCompletedOn?.value || "",
        assigned_date_days_ago: filters.handoverCompletedOn?.value || "",
        last_checkin_days_ago: filters.lastCheckedIn?.value || "",
        trnr_intro_status: filters.selTrainerIntro?.value || "",
        is_pt_prspct: filters.selPTProspect?.value || "",
        last_checkin_time_filter: last_checkin_start_end_time || "",
        biomax_first_step: filters.selBiomaxAppRegister?.value || "",
        added_from: filters.selTrialAddedFrom?.value || "",
        three_day_assigned: filters.selectedPTTrial?.value || "",
        converted: filters.selectedConvertedStatus?.value || "",
        start_date: filters.selSubscriptionAddDateFrom || "",
        end_date: filters.selSubscriptionAddDateTo || "",
        pt_schedule_start_date: filters.selPtScheduleDateFrom || "",
        pt_schedule_end_date: filters.selPtScheduleDateTo || "",
        expctd_closure_start_date: filters.selExpCloserDateFrom || "",
        expctd_closure_end_date: filters.selExpCloserDateTo || "",
        threeday_assign_from: filters.selPtTrialAssignedDateFrom || "",
        threeday_assign_to: filters.selPtTrialAssignedDateTo || "",
        payment_location: filters.selectedPaymentLocation?.value || "",
        bca_report_status: filters.bcaReportStatus?.value || "",
        three_day_done_count: filters.threeDayDoneCount?.value || "",
        three_day_done_from: filters.selThreeDayDoneDateFrom || "",
        three_day_done_to: filters.selThreeDayDoneDateTo || "",
        is_future_subscription: filters.isFutureSubscription || false,
        future_trial: toggle ? 1 : 0,
      }));
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [
    filters.selectedGym?.value,
    filters.selectedTrainer?.value,
    filters.selectedSubsAddedBy?.value,
    filters.selectedReceptionist?.value,
    filters.selectedPTTrialStatus?.value,
    filters.selProspectStatus?.value,
    filters.selectedHandoverStatus?.value,
    filters.trialCompletedOn?.value,
    filters.handoverCompletedOn?.value,
    filters.lastCheckedIn?.value,
    filters.selTrainerIntro?.value,
    filters.selPTProspect?.value,
    filters.selBiomaxAppRegister?.value,
    filters.selTrialAddedFrom?.value,
    filters.selectedPTTrial?.value,
    filters.selectedConvertedStatus?.value,
    filters.selSubscriptionAddDateFrom,
    filters.selSubscriptionAddDateTo,
    filters.selPtScheduleDateFrom,
    filters.selPtScheduleDateTo,
    filters.selExpCloserDateFrom,
    filters.selExpCloserDateTo,
    filters.selPtTrialAssignedDateFrom,
    filters.selPtTrialAssignedDateTo,
    filters.selectedPaymentLocation?.value,
    filters.bcaReportStatus?.value,
    filters.threeDayDoneCount?.value,
    filters.selThreeDayDoneDateFrom,
    filters.selThreeDayDoneDateTo,
    filters.isFutureSubscription,
    toggle,
    last_checkin_start_end_time,
    trainerReceptionistInfo?.gym_id,
    trainerReceptionistInfo?.user_id,
    isTrainer,
    isReceptionist,
  ]);

  //   CLEAR SEACH FILTER
  useEffect(() => {
    if (filters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setPTDatas((prevs) => ({ ...prevs, isPage: 0 }));
      setSendableFilters((prevs) => ({ ...prevs, search: "" }));
    }
  }, [filters.searchString]);

  return (
    <>
      <Modal
        isOpen={pttModal}
        onRequestClose={closeOpenModal}
        contentLabel="PT Trial Info Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer">
          <ModalHeadAndClose
            title="Add PT Trial Info"
            onClose={closeOpenModal}
          />
          {isReceptionist || isFitnessManager ? (
            <ReceptionistForm
              receptionistInfo={trainerReceptionistInfo}
              closeModal={closeOpenModal}
              decryptedText={decryptedText}
              callFunction={() => {
                getPTTrialStatsData(sendableStatsFilters);
                getPtTracksData(sendableFilters);

                if (
                  (isReceptionist || isFitnessManager) &&
                  trainerReceptionistInfo?.user_id
                ) {
                  handleTotalSubsGymwiseData(trainerReceptionistInfo.user_id);
                  handleTotalHandoverByMeData(trainerReceptionistInfo.user_id);
                }

                if (isFitnessManager && trainerReceptionistInfo?.user_id) {
                  handleTotalTrialInitiatedByMeData(
                    trainerReceptionistInfo.user_id
                  );
                }
              }}
              isShowBackBtn={true}
              name={"edit"}
            />
          ) : (
            <PTTrialForm
              trainerInfo={trainerReceptionistInfo}
              closeModal={closeOpenModal}
              decryptedText={decryptedText}
              callFunction={() => {
                getPTTrialStatsData(sendableStatsFilters);
                getPtTracksData(sendableFilters);

                if (
                  (isReceptionist || isFitnessManager) &&
                  trainerReceptionistInfo?.user_id
                ) {
                  handleTotalSubsGymwiseData(trainerReceptionistInfo.user_id);
                  handleTotalHandoverByMeData(trainerReceptionistInfo.user_id);
                }

                if (isFitnessManager && trainerReceptionistInfo?.user_id) {
                  handleTotalTrialInitiatedByMeData(
                    trainerReceptionistInfo.user_id
                  );
                }
              }}
              isShowBackBtn={true}
            />
          )}
        </div>
      </Modal>

      <Modal
        isOpen={showTable}
        onRequestClose={onCLoseModal}
        contentLabel="PT Trial Info Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer">
          <ModalHeadAndClose title="PT Trial Info" onClose={onCLoseModal} />

          <PTTableFilters
            filters={filters}
            setFilters={setFilters}
            onClickSearch={onClickSearch}
            handleKeyPress={handleKeyPress}
            onClickReset={onClickReset}
            searchFilterApplied={searchFilterApplied}
            decryptedText={decryptedText}
            ptAdminDate={true}
            ptDatas={ptDatas}
            setSendableStatsFilters={setSendableStatsFilters}
            isExport={true}
            onClickExportBtn={() =>
              setClickValues({
                isModOpen: true,
                name: "exportModal",
              })
            }
            isPTOpen={isOpenAccessible}
            isLoading={ptTracksDataLoading}
            handleToggle={handleToggle}
            toggle={toggle}
          />

          {ptTracksDataLoading ? (
            <TableSkeleton columns={9} rows={5} isFirstColSticky={true} />
          ) : (
            <PTTrialTable1
              ptDatas={ptDatas}
              setPTDatas={setPTDatas}
              decryptedText={decryptedText}
              callFunction={() => {
                getPTTrialStatsData(sendableStatsFilters);
                getPtTracksData(sendableFilters);

                if (
                  (isReceptionist || isFitnessManager) &&
                  trainerReceptionistInfo.user_id
                ) {
                  handleTotalSubsGymwiseData(trainerReceptionistInfo.user_id);
                  handleTotalHandoverByMeData(trainerReceptionistInfo.user_id);
                }

                if (isFitnessManager && trainerReceptionistInfo.user_id) {
                  handleTotalTrialInitiatedByMeData(
                    trainerReceptionistInfo.user_id
                  );
                }
              }}
              receptionistInfo={trainerReceptionistInfo}
              isAddedByMe={isAddedByMe}
              addedByMe={addedByMe}
              setAddedByMe={setAddedByMe}
            />
          )}
        </div>
      </Modal>

      <Modal
        isOpen={clickValues.isModOpen}
        onRequestClose={onCloseClickValuesModal}
        contentLabel="Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer`}>
          {clickValues.name === "exportModal" ? (
            <>
              <ModalHeader
                title={"Select Fields To Export"}
                onClick={onCloseClickValuesModal}
              />
              <div>
                <SelectExportables
                  name={"pt-reports"}
                  exportableData={exportableData}
                  filters={sendableFilters}
                  setFilters={setSendableFilters}
                  callFunction={onClickExport}
                  isLoadingCSV={exportLoading}
                  csvData={csvData}
                  setCsvData={setCsvData}
                />
              </div>
            </>
          ) : null}
        </div>
      </Modal>

      <Row>
        <Col>
          <div className="discount-payments-tabs bgTransParent odm-wati-container">
            <Tabs>
              <TabList>
                <Tab>PT Trial</Tab>
                <Tab>PT Reports</Tab>
                {(isAdmin || isManagerRole) && <Tab>Member Reports</Tab>}
                {(isAdmin || isManagerRole) && (
                  <Tab>Gymwise PT Trial Reports</Tab>
                )}
              </TabList>

              <TabPanel>
                {isOpenAccessible ? (
                  <BackAddBtns
                    isCustom={isOpenAccessible}
                    onClickBack={isOpenAccessible ? handleBack : null}
                    onClickReload={() => {
                      getPTTrialStatsData(sendableStatsFilters);
                      getPtTracksData(sendableFilters);
                    }}
                    isAddBtn={true}
                  />
                ) : null}

                <PTTrialFilters
                  ptDatas={ptDatas}
                  filters={filters}
                  setFilters={setFilters}
                  setSendableStatsFilters={setSendableStatsFilters}
                  setSendableFilters={setSendableFilters}
                  setPTDatas={setPTDatas}
                  onClickSearch={onClickSearch}
                  onClickReset={onClickResetStats}
                  searchFilterApplied={searchFilterApplied}
                  decryptedText={decryptedText}
                  isLoading={ptTracksDataLoading || ptTrialStatsLoading}
                  handleToggle={handleToggle}
                  toggle={toggle}
                  isReload={() => {
                    getPTTrialStatsData(sendableStatsFilters);
                    getPtTracksData(sendableFilters);
                  }}
                />

                <PTTrackCards
                  setShowTable={setShowTable}
                  ptDatas={ptDatas}
                  filters={filters}
                  setFilters={setFilters}
                  activeKey={activeKey}
                  setActiveKey={setActiveKey}
                  onClickReset={onClickReset}
                  isTrainer={isTrainer}
                  isReceptionist={isReceptionist}
                  isFitnessManager={isFitnessManager}
                  isAddedByMe={isAddedByMe}
                  setIsAddedByMe={setIsAddedByMe}
                  addedByMe={addedByMe}
                />
              </TabPanel>
              <TabPanel>
                <PTReports
                  decryptedText={decryptedText}
                  prevFilters={ptReportsFilters}
                  callFunction={() => {
                    getPTTrialStatsData(sendableStatsFilters);
                    getPtTracksData(sendableFilters);
                  }}
                  receptionistInfo={trainerReceptionistInfo}
                />
              </TabPanel>
              {(isAdmin || isManagerRole) && (
                <TabPanel>
                  <MemberReport userInfoData={decryptedText} />
                </TabPanel>
              )}
              {(isAdmin || isManagerRole) && (
                <TabPanel>
                  <GymWiseStats
                    userInfoData={decryptedText}
                    prevFilters={filters}
                  />
                </TabPanel>
              )}
            </Tabs>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default PTTrackStructure;
